/* eslint-disable */
export const InnovativeProdDevItems = [
  {
    "srno": 1,
    "productID": "3015",
    "rLDProduct_Dev": "Hybrid Application",
    "productName": "Melatonin Dual Release Formulation 5 mg",
    "productDevStatus": "Done",
    "ipStatus": "Pending",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Multiparticulates of Melatonin.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 2,
    "productID": "3051",
    "rLDProduct_Dev": "505(b)2",
    "productName": "Enzalutamide Oral Solution",
    "productDevStatus": "Done",
    "ipStatus": "Pending",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Stability ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 3,
    "productID": "4001",
    "rLDProduct_Dev": "DissolVR",
    "productName": "R0701 - (Melatonin Oral Solution (2 mg / ml)",
    "productDevStatus": "Done",
    "ipStatus": "Done",
    "labStability": "Done",
    "poc": "Done",
    "licensing": "Ready for Filing",
    "remark": "Patented Formulation (EP 4021411A4 / AU2020339867A1)",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 4,
    "productID": "4002",
    "rLDProduct_Dev": "DissolVR",
    "productName": "R0702 - (Melatonin Oral Solution (3 mg / ml)",
    "productDevStatus": "Done",
    "ipStatus": "Done",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Ready fro Tech Transfer",
    "remark": "Development done. Patented Composition",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 5,
    "productID": "4003",
    "rLDProduct_Dev": "DissolVR",
    "productName": "R0703 - (Melatonin Injection)",
    "productDevStatus": "Done",
    "ipStatus": "NA",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Ready fro Tech Transfer",
    "remark": "Development done. Patented Composition",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 6,
    "productID": "4004",
    "rLDProduct_Dev": "DissolVR",
    "productName": "R0704 - (Nimodipine Oral Solution 10 mg / ml)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Ready fro Tech Transfer",
    "remark": "Alcohol free stable composition. Patented",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 7,
    "productID": "4005",
    "rLDProduct_Dev": "DissolVR",
    "productName": "R0705 - (Nimodipine Concentrate Injection)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Ready fro Tech Transfer",
    "remark": "Alcohol free stable composition for IV administration",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 8,
    "productID": "4006",
    "rLDProduct_Dev": "DissolVR",
    "productName": "R0706 - (Potassium-competitive acid blocker)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Ready fro Tech Transfer",
    "remark": "Free of Propylene Glycol. Patented.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 9,
    "productID": "4007",
    "rLDProduct_Dev": "Ezegest",
    "productName": "R0401 - (Metformin Powder for Solution 1 gm (High Dose)",
    "productDevStatus": "Done",
    "ipStatus": "NA",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Ready fro Tech Transfer",
    "remark": "Stability Done. Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 10,
    "productID": "4008",
    "rLDProduct_Dev": "Ezegest",
    "productName": "R0402 - (Dexamethasone Tablets 40 mg) High Dose",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Ready fro Tech Transfer",
    "remark": "High Dose Composition.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 11,
    "productID": "4009",
    "rLDProduct_Dev": "Ezegest",
    "productName": "R0403 - (Etraverine Powder For Oral Suspension (10 mg / ml)",
    "productDevStatus": "Done",
    "ipStatus": "Done",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Solvent-free",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 12,
    "productID": "4010",
    "rLDProduct_Dev": "Ezegest",
    "productName": "R0404 - (Abirateron Acetate Powder For Solution)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Development ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 13,
    "productID": "4013",
    "rLDProduct_Dev": "P2C",
    "productName": "R0801 - (Luliconazole 1% w/w Cream)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Novel powder 2 cream formulation.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 14,
    "productID": "4014",
    "rLDProduct_Dev": "P2C",
    "productName": "R0802 - (Tofacitinib Ointment)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Novel powder 2 cream formulation.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 15,
    "productID": "4018",
    "rLDProduct_Dev": "Rapisol",
    "productName": "R0203 - (Ramelteon Sublingual Film 8 mg / Oral Film)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Development ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 16,
    "productID": "4019",
    "rLDProduct_Dev": "Rapisol",
    "productName": "R0204 - (Melatonin Oral Dissolving Film)",
    "productDevStatus": "Done",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Development done. Stability ongoing.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 17,
    "productID": "4020",
    "rLDProduct_Dev": "ZeroCR",
    "productName": "R0101 - (Methylphenedate ER Suspension)",
    "productDevStatus": "Ongoing",
    "ipStatus": "TBD",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Development done. No Ion Exchange Resin.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 18,
    "productID": "4021",
    "rLDProduct_Dev": "Ezegest",
    "productName": "Methanamine Hippurate Powder for Suspension 500 / 1000 mg (1000 mg)",
    "productDevStatus": "Done",
    "ipStatus": "N/A",
    "labStability": "Ongoing",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Tech Trasnfer Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 19,
    "productID": "4022",
    "rLDProduct_Dev": "DissolVR",
    "productName": "Methanamine Hippurate Oral Solution (100 mg / ml)",
    "productDevStatus": "Done",
    "ipStatus": "N/A",
    "labStability": "Ongoing",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Tech Trasnfer Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 20,
    "productID": "3046",
    "rLDProduct_Dev": "Rapisol",
    "productName": "Tofacitinib Oral Dissolving Film (5 and 10 mg)",
    "productDevStatus": "Done",
    "ipStatus": "Pending",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Ready for Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 21,
    "productID": "3047",
    "rLDProduct_Dev": "Rapisol",
    "productName": "Dapagliflozin Oral Dissolving Film (5 and 10 mg)",
    "productDevStatus": "Ongoing",
    "ipStatus": "Pending",
    "labStability": "Pending",
    "poc": "Pending",
    "licensing": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  }
];
